import {DashboardQueryOrigin} from 'common/report/dashboards/types';

export enum QueryReason {
  // Viewing a bookmark (either from loading a bookmark url or selecting a bookmark from the bookmark picker)
  BookmarkView = `bookmark_view`,
  // Navigated from another report
  NavFromOtherReport = `nav_from_other_report`,
  // Non-user triggered query builder updates (e.g. custom properties store update from a mp-properties-menu)
  QbAutoTriggered = `qb_auto_triggered`,
  QbBreakdownUpdate = `qb_breakdown_update`,
  QbFilterUpdate = `qb_filter_update`,
  // Any other query builder update that isn't classified as one of the other reasons
  QbOtherUpdate = `qb_other_update`,
  QbQTSUpdate = `qb_qts_update`,
  // Custom alert modal anomaly query used for the anomaly preview
  CustomAlertModalAnomalyPreview = `custom_alert_anomaly_preview`,
  WarehouseImportPreview = `warehouse_import_preview`,
}

export type QueryTrackingProps = {
  report_name: string;
  dashboard_id?: number;
  dashboard_query_origin?: DashboardQueryOrigin;
  bookmark_id?: number;
  has_unsaved_changes?: boolean;
  is_main_query_for_report?: boolean;
  queried_from_dashboards?: boolean;
  query_reason?: QueryReason;
  request_url?: string;
};
